import _ from 'lodash'

export const icon = 'chart-mixed'
export const humanName = {
  singular: 'Analytics',
  plural: 'Analytics'
}
export const getConfig = props => {
  const { digitalProductId } = props
  const basePath = '/p/analytics'
  const apiBasePath = '/user/digital_products'
  const config = {
    basePath,
    apiBasePath,
    customAction: 'gamification_dashboard',
    icon,
    humanName,
    options: {
      retry: true,
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
      refetchInterval: 30000
    }
  }

  return config
}
